import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/apiClient";

const TABS = [
  { key: "student", label: "Students", path: "/admin/student-applications" },
  { key: "franchise", label: "Franchise", path: "/admin/franchise-leads" },
  { key: "event", label: "Event Orders", path: "/admin/event-orders" },
  { key: "bulk", label: "Bulk Orders", path: "/admin/bulk-orders" },
  { key: "contact", label: "Contact", path: "/admin/contact-inquiries" },
];

const STATUSES = ["new", "in_progress", "won", "lost"];

export default function AdminLeads() {
  const [active, setActive] = useState(TABS[0]);
  const [items, setItems] = useState([]);
  const load = async () => { const r = await api.get(active.path); setItems(r.data || []); };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [active]);

  const setStatus = async (id, status) => {
    if (active.key === "contact") return;
    await api.put(`${active.path}/${id}/status`, { status });
    toast.success(`Set ${status}`); load();
  };

  return (
    <div data-testid="admin-leads" className="space-y-8">
      <header>
        <div className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Leads & Orders</div>
        <h1 className="editorial-h1 text-5xl mt-2">Everything that lands in our inbox.</h1>
      </header>
      <div className="flex flex-wrap gap-2">
        {TABS.map((t) => (<button key={t.key} onClick={() => setActive(t)} data-testid={`leads-tab-${t.key}`} className={`btn-pill text-xs ${active.key === t.key ? "btn-dark" : "btn-ghost border border-brand-line"}`}>{t.label}</button>))}
      </div>

      <div className="card-elevated overflow-x-auto">
        <table className="w-full text-sm" data-testid={`leads-table-${active.key}`}>
          <thead className="text-left text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">
            <tr className="border-b border-brand-line">
              <th className="p-4">Name</th><th className="p-4">Contact</th><th className="p-4">Detail</th>
              <th className="p-4">Status</th><th className="p-4">When</th>
            </tr>
          </thead>
          <tbody>
            {items.map((i) => (
              <tr key={i.id} className="border-b border-brand-line last:border-0 align-top" data-testid={`lead-row-${i.id}`}>
                <td className="p-4 font-medium">{i.full_name || i.name}</td>
                <td className="p-4 text-brand-charcoal/75">
                  <div>{i.email}</div>
                  <div className="text-xs text-brand-charcoal/55">{i.phone}</div>
                </td>
                <td className="p-4 text-brand-charcoal/75 max-w-md">
                  {active.key === "student" && <span>{i.college} · {i.course} · {i.year_of_study} <div className="text-xs text-brand-charcoal/55 mt-1">{(i.interest_areas || []).join(", ")}</div></span>}
                  {active.key === "franchise" && <span>{i.city}, {i.state} · {i.investment_capacity}</span>}
                  {active.key === "event" && <span>{i.event_type} · {i.event_date} · {i.location} · {i.estimated_guests} guests</span>}
                  {active.key === "bulk" && <span>{i.quantity} pcs to {i.delivery_city} {i.company && `(${i.company})`}</span>}
                  {active.key === "contact" && <span>{i.subject}: {i.message?.slice(0, 80)}…</span>}
                </td>
                <td className="p-4">
                  {active.key === "contact" ? (<span className="text-xs">{i.status}</span>) : (
                    <select data-testid={`lead-status-${i.id}`} className="text-xs border border-brand-line rounded-full px-2 py-1 bg-white" value={i.status || "new"} onChange={(e) => setStatus(i.id, e.target.value)}>
                      {STATUSES.map((s) => (<option key={s} value={s}>{s}</option>))}
                    </select>
                  )}
                </td>
                <td className="p-4 text-xs text-brand-charcoal/55">{(i.created_at || "").slice(0, 10)}</td>
              </tr>
            ))}
            {items.length === 0 && (<tr><td colSpan="5" className="p-8 text-center text-brand-charcoal/60">No entries yet.</td></tr>)}
          </tbody>
        </table>
      </div>
    </div>
  );
}
